import { render } from "./template-group.vue?vue&type=template&id=b4e1eb04&scoped=true"
import script from "./template-group.vue?vue&type=script&lang=js"
export * from "./template-group.vue?vue&type=script&lang=js"

import "./template-group.vue?vue&type=style&index=0&id=b4e1eb04&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4e1eb04"]])

export default __exports__